import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import Slide1Capa from '../components/pitch/Slide1Capa';
import Slide2Persona from '../components/pitch/Slide2Persona';
import Slide3Dor from '../components/pitch/Slide3Dor';
import Slide4Validacao from '../components/pitch/Slide4Validacao';
import Slide5Dados from '../components/pitch/Slide5Dados';
import Slide6SolucaoWithScreenshot from '../components/pitch/Slide6SolucaoWithScreenshot';
import Slide6_5DashboardScreenshot from '../components/pitch/Slide6_5DashboardScreenshot';
import Slide7Concorrentes from '../components/pitch/Slide7Concorrentes';
import Slide7_5PlanejamentoScreenshot from '../components/pitch/Slide7_5PlanejamentoScreenshot';
import Slide8IAWithScreenshot from '../components/pitch/Slide8IAWithScreenshot';
import Slide8_5AnalyticsScreenshot from '../components/pitch/Slide8_5AnalyticsScreenshot';
import Slide9MetodologiaWithScreenshot from '../components/pitch/Slide9MetodologiaWithScreenshot';
import Slide9_5ColaboracaoScreenshot from '../components/pitch/Slide9_5ColaboracaoScreenshot';
import Slide10Modelo from '../components/pitch/Slide10Modelo';
import Slide10_5SwotScreenshot from '../components/pitch/Slide10_5SwotScreenshot';
import Slide11GoToMarket from '../components/pitch/Slide11GoToMarket';
import Slide11_5MetodologiaScreenshot from '../components/pitch/Slide11_5MetodologiaScreenshot';
import Slide12Fundadores from '../components/pitch/Slide12Fundadores';
import Slide12_5IntegracaoScreenshot from '../components/pitch/Slide12_5IntegracaoScreenshot';
import Slide13CTA from '../components/pitch/Slide13CTA';

const PitchContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
`;

const NavigationDots = styled.div`
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 1000;
`;

const Dot = styled.button<{ active: boolean }>`
  width: ${(props: { active: boolean }) => props.active ? '12px' : '8px'};
  height: ${(props: { active: boolean }) => props.active ? '12px' : '8px'};
  border-radius: 50%;
  background: ${(props: { active: boolean }) => props.active ? '#EF443C' : '#042E4B'};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: ${(props: { active: boolean }) => props.active ? '1' : '0.5'};

  &:hover {
    opacity: 1;
    transform: scale(1.2);
  }
`;

const ClickArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  z-index: 500;
  cursor: pointer;
`;

const LeftArea = styled.div``;
const RightArea = styled.div``;

const PitchDeck: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 20;

  const slides = [
    <Slide1Capa key="slide1" />,
    <Slide2Persona key="slide2" />,
    <Slide3Dor key="slide3" />,
    <Slide4Validacao key="slide4" />,
    <Slide5Dados key="slide5" />,
    <Slide6SolucaoWithScreenshot key="slide6" />,
    <Slide6_5DashboardScreenshot key="slide6_5" />,
    <Slide7Concorrentes key="slide7" />,
    <Slide7_5PlanejamentoScreenshot key="slide7_5" />,
    <Slide8IAWithScreenshot key="slide8" />,
    // <Slide8_5AnalyticsScreenshot key="slide8_5" />,
    <Slide9MetodologiaWithScreenshot key="slide9" />,
    <Slide9_5ColaboracaoScreenshot key="slide9_5" />,
    <Slide10Modelo key="slide10" />,
    <Slide10_5SwotScreenshot key="slide10_5" />,
    <Slide11GoToMarket key="slide11" />,
    <Slide11_5MetodologiaScreenshot key="slide11_5" />,
    <Slide12Fundadores key="slide12" />,
    <Slide12_5IntegracaoScreenshot key="slide12_5" />,
    <Slide13CTA key="slide13" />,
  ];

  const nextSlide = () => {
    if (currentSlide < totalSlides - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
        case 'PageDown':
        case ' ':
          e.preventDefault();
          nextSlide();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
        case 'PageUp':
          e.preventDefault();
          prevSlide();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);

  return (
    <PitchContainer>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
          style={{ width: '100%', height: '100%' }}
        >
          {slides[currentSlide]}
        </motion.div>
      </AnimatePresence>

      <ClickArea>
        <LeftArea onClick={prevSlide} />
        <RightArea onClick={nextSlide} />
      </ClickArea>

      <NavigationDots>
        {slides.map((_, index) => (
          <Dot
            key={slides[index].key}
            active={index === currentSlide}
            onClick={() => goToSlide(index)}
          />
        ))}
      </NavigationDots>
    </PitchContainer>
  );
};

export default PitchDeck;
